var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex sm10 md10" },
    [
      _c(
        "FormFieldsContainer",
        [
          _c(
            "v-flex",
            { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { sm3: "", md3: "" } },
                    [
                      _c("DatePicker", {
                        attrs: {
                          label: _vm.formFields.fechaInicio.label,
                          "error-messages": _vm.errors.collect(
                            _vm.formFields.fechaInicio.id
                          ),
                          id: _vm.formFields.fechaInicio.id,
                          max: _vm.fechaMaximaInicio.format("YYYY-MM-DD"),
                          clearable: ""
                        },
                        model: {
                          value: _vm.formFields.fechaInicio.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.fechaInicio, "value", $$v)
                          },
                          expression: "formFields.fechaInicio.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm3: "", md3: "" } },
                    [
                      _c("DatePicker", {
                        attrs: {
                          label: _vm.formFields.fechaFin.label,
                          "error-messages": _vm.errors.collect(
                            _vm.formFields.fechaFin.id
                          ),
                          id: _vm.formFields.fechaFin.id,
                          max: _vm.fechaMaximaInicio.format("YYYY-MM-DD"),
                          clearable: ""
                        },
                        model: {
                          value: _vm.formFields.fechaFin.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.fechaFin, "value", $$v)
                          },
                          expression: "formFields.fechaFin.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm3: "", md3: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.formFields.requerimiento.label,
                          "prepend-icon": "home_repair_service",
                          clearable: ""
                        },
                        model: {
                          value: _vm.formFields.requerimiento.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.requerimiento, "value", $$v)
                          },
                          expression: "formFields.requerimiento.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm3: "", md3: "" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: _vm.formFields.estado.label,
                          items: _vm.estadosList,
                          "item-text": "configvalor",
                          "item-value": "configid",
                          "prepend-icon": "filter_list",
                          clearable: ""
                        },
                        model: {
                          value: _vm.formFields.estado.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.estado, "value", $$v)
                          },
                          expression: "formFields.estado.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm3: "", md3: "" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: _vm.formFields.notestado.label,
                          items: _vm.estadosList,
                          "item-text": "configvalor",
                          "item-value": "configid",
                          "prepend-icon": "filter_list",
                          multiple: ""
                        },
                        model: {
                          value: _vm.formFields.notestado.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.notestado, "value", $$v)
                          },
                          expression: "formFields.notestado.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm3: "", md3: "" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: _vm.formFields.razonsocial.label,
                          items: _vm.razonsocialList,
                          "item-text": "nombre",
                          "item-value": "rut",
                          "prepend-icon": "apartment",
                          clearable: ""
                        },
                        model: {
                          value: _vm.formFields.razonsocial.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.razonsocial, "value", $$v)
                          },
                          expression: "formFields.razonsocial.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm3: "", md3: "" } },
                    [
                      _c(
                        "v-btn",
                        { on: { click: _vm.handleBuscarClick } },
                        [
                          _c(
                            "v-icon",
                            { attrs: { color: "rgb(39, 72, 142)" } },
                            [_vm._v("search")]
                          ),
                          _vm._v("Filtrar\n          ")
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        { on: { click: _vm.clearFilters } },
                        [
                          _c(
                            "v-icon",
                            { attrs: { color: "rgb(39, 72, 142)" } },
                            [_vm._v("clear")]
                          ),
                          _vm._v("Limpiar\n          ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("div", { staticClass: "clearfix", staticStyle: { width: "100%" } })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }